import styles from "../../../styles/NotesIcon.module.scss";
import Image from "@src/lib/Image";
import { getAwsAssets } from "@src/utils";

const NotesButton = ({ onClick }) => {
  const handleNotesClick = (e) => {
    e?.stopPropagation();
    onClick && onClick();
  };

  return (
    <div className={styles.notesIcon} onClick={handleNotesClick}>
      <Image
        src = {getAwsAssets("notesIcon.svg", "content")}
        alt="NotesImg"
        height={40}
        width={50}
        eager={true}
        objectFit="contain"
      />

      <Image
        src = {getAwsAssets("Vector.svg", "content")}
        alt="ArrowRight"
        height={10}
        width={20}
        eager={true}
        objectFit="contain"
      />
    </div>
  );
};

export default NotesButton;